module.exports = __webpack_public_path__ + "static/media/Spanish-Future-Tense1.e8fd0744.jpg";